import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, DefaultValueAccessor } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { LoaderService } from '../shared/providers/loader.service';
import { CommonService } from '../shared/providers/common.service';
import { IMarkettingTableModel, IUtmDetailData, IUtmSource } from '../shared/models/MarkettingTableModel';
import { ValidationService } from '../shared/providers/validation.service';

declare var require: any;
if (typeof Highcharts === 'object') {

  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}
interface IMarkettingData {
  type: string;
  name: number;
  data: number[];
  color: string;
}
@Component({
  selector: 'app-marketting-dashboard',
  templateUrl: './marketting-dashboard.component.html',
  styleUrls: ['./marketting-dashboard.component.css']
})
export class MarkettingDashboardComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private cdRef: ChangeDetectorRef, private userManagerService: UserManagerService, private loaderService: LoaderService, private _commonService: CommonService, public Validation: ValidationService) {

  }
  barChartData = [] as any;
  UTMData = [] as any;
  actionList = [] as any;
  months = [];
  chartData: IMarkettingData = {} as any;
  selectedValue = 3;
  selectedAction = 'All';
  modalRef: BsModalRef;
  user: any;
  activetab: string;
  selectedUtmsource = 'All';
  range: string[] = [];
  allUtmCount: IMarkettingTableModel[];
  allActionCount: IUtmDetailData[];
  allvalCount: IUtmDetailData[];
  currentYear: number;
  monthList: string[] = [];
  tableactionList: string[] = [];
  utmSouceList: IUtmSource[];
  monthcount: number = 0;
  @Input() dataerange: number = 0;
  yearLst: any[];
  curyear: number;
  private chartLabelOptions = {
    style: {
      fontSize: '12px'
    }
  };
  ngOnInit(): void {
    this.getData();
    this.activetab = "Chart";
    this.getUtmActionList();

  }

  /*Get Data for Graph*/
  getData() {
    this.loaderService.display(true);
    let img: any = {
      selectedValue: this.selectedValue,
      selectedAction: this.selectedAction,
      selectedUTMSource: "All"
    };
    this._commonService.GetMarkettingDashboardData1(img).subscribe(response => {
      let data = response;
      this.UTMData = data;
      var userroles = this.UTMData.map(item => item.UTMSource)
        .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a.localeCompare(b));;
      userroles.filter((el, i, a) => i === a.indexOf(el));
      var x = this.UTMData.map(o => ({ Month: o.Month, Year: o.Year }))

      this.months = x.map(ar => JSON.stringify(ar))
        .filter((itm, idx, arr) => arr.indexOf(itm) === idx)
        .map(str => JSON.parse(str));

      let chatDataColor = 0;
      userroles.forEach(item => {
        this.chartData = {} as any;
        this.chartData.data = [] as any;
        this.chartData.name = item;
        let chartColor = (item.toLowerCase() == 'b+e' || item.toLowerCase() == 'be_web') ? '#198FDE' : item.toLowerCase() == 'bizbuysell' ? '#28b7f1'
          : item.toLowerCase() == 'crexi' ? '#337ab7' : item.toLowerCase() == 'brevitas' ? '#00274b' : item.toLowerCase() == 'commconn' ? ' #656565'
            : (item.toLowerCase() == 'fb' || item.toLowerCase() == 'facebook') ? '#3b5998' : (item.toLowerCase() == 'hs_email' || item.toLowerCase() == 'hubspot') ? '#f57722'
              : item.toLowerCase() == 'linkedin' ? '#0e76a8' : item.toLowerCase() == 'loopnet' ? '#cf0000' : item.toLowerCase() == 'nnnmarket' ? '#ffc107'
                : item.toLowerCase() == 'other' ? '#003A5D' : (item.toLowerCase() == 'total commercial' || item.toLowerCase() == 'totalcomm') ? '#296192' : '';
        if (chartColor != '' && chartColor != undefined) {
          this.chartData.color = chartColor;
        }
        else {
          this.chartData.color = this.getChartColor(chatDataColor);
        }
   
        this.chartData.type = 'column';
        this.months.forEach(t => {
          var countvalue = this.UTMData.filter(i => i.Month == t.Month && i.Year == t.Year && i.UTMSource == item).map(i => i.Count);
          var val = 0;
          var count = 0;
          countvalue.forEach(element1 => {
            val = val + element1;
            count = 1;

          });
          if (countvalue != null && countvalue.length>0) {
            this.chartData.data.push(val == undefined ? null : val);

          }
          else {
            this.chartData.data.push(null);
          }
        });

        this.barChartData.push(this.chartData);
        console.log(this.barChartData);
        chatDataColor++;
      });
      this.bindChart();
    });
  }

  /*Bind Chart*/

  bindChart() {
    let mydata = this.UTMData;
    var columnRange = this.chartData.data.find(i => i)[0];
    const chart = {
      chart: {
        type: 'column',
        height: 400,
      },

      title: {
        text: ''
      },
      xAxis: {
        categories: this.months.map(i => i.Month),
        crosshair: true,
        labels: this.chartLabelOptions
      },

      yAxis: [{
        min: 0,
        labels: {
          formatter: function () {
            if (this.value >= 0) {
              return this.value
            }
          },
          ...this.chartLabelOptions
        },
        title: {
          text: ''
        },
        allowDecimals: false
      }, {
        opposite: true,
        labels: {
          format: '{value}'
        },
        allowDecimals: true,

      }],
      legend: {
        enabled: true,
        itemStyle: {
          fontWeight: 'normal',
          fontSize: '12px'
        }
      },
      credits: {
        enabled: false
      },

      tooltip: {
        headerFormat: '<span style="font-size:13px"><b>{point.key} - {point.series.name}</b></span><table>',

        pointFormatter: function () {
          var currentPoint = this,
            currentSeries = currentPoint.series,
            chart = currentSeries.chart,
            stackName = '',
            stackValues = '';
          var currentmonth = currentPoint.category;
          let unique = [];
          if (mydata.findIndex(x => x.Month == currentPoint.category && x.UTMSource == currentSeries.name) > -1) {
            let newactions = mydata;
            newactions = newactions.filter(x => x.Month == currentmonth && x.UTMSource == currentSeries.name);
            newactions.forEach(element => {
              if (!unique.includes(element.Action)) {
                unique.push(element.Action);
                if (stackName != null && stackName != '') {
                  stackName = stackName + '<tr><td style="padding:0">' + element.Action + ' - </td><td style="padding:0">' + element.Count + '</td></tr>';
                }
                else {
                  stackName = '<tr><td style="padding:0">' + element.Action + ' - </td><td style="padding:0">' + element.Count + '</td></tr>';

                }
              }
            });
          }
          return '<b></b>' + stackName + '<br/><b>';
        },
        footerFormat: '</table>',
        distance: 30,
        shared: false,
        useHTML: true,
        shadow: false,
        floating: true,

      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          minPointLength: 3,
          ignoreNulls: 'normal',
          //dataLabels: {
          //  enabled: true,
          //  useHTML:true,
          //  formatter: function () {
          //    if (this.point.y > 0) {
          //      return this.point.y;
          //    }
          //  }
          //}
        },

      },
      series: this.barChartData
    }

    console.log(this.barChartData)
    Highcharts.chart('container', chart);
    this.loaderService.display(false);
  }
  getChartColor(index) {
    const colors = [' #6596D6 ', ' #67A7FA ', ' #1967CB ', ' #0D77FF ', ' #004298 ', ' #285CA1 ', ' #55759E ', ' #4788DC ', ' #5167EA ', ' #2B44D8 ', ' #7582CF ', ' #4354B9 ', ' #0F24A4 ', ' #1458E2 ', ' #3562BF ', ' #305297 ', ' #333286 ', ' #98C7FF ', ' #4886D8 ', ' #2C99D7 ', ' #157BB5 ', ' #0C6699 ', ' #49A1D3 ', ' #62BFF3 ', ' #51B5D1 ', ' #6186D3 ', ' #33C5DF ', ' #21A5BC ', ' #277583 ', ' #274183 ', ' #21459E ', ' #4674E6 ', ' #3355AA ', ' #596C9C ', ' #503C8D ', ' #6042BE ', ' #906CFF ', ' #B08CC8 ', ' #A374AE ', ' #B4658E ', ' #CA62DF ', ' #A264D9 ', ' #90B36C ', ' #6C963D ', ' #6AB16A ', ' #75D285 ', ' #B3BB66 ', ' #C77272 ', ' #D75555 ', ' #A34646 ']
    return colors[index];
  }

  /* To change the view */

  onViewChange(view: number) {
    if (view == 1) {
      if (this.activetab != 'Chart') {
        this.barChartData = [];
        this.getData();
      }
      this.activetab = 'Chart';
    }
    else {
      this.allUtmCount = [];
      this.utmSouceList = [];
      this.allActionCount = [];
      this.getTableData();
      this.activetab = 'Table';
    }
  }

  onActionSelect() {
    if (this.activetab == "Chart") {
      this.barChartData = [];
      this.getData();
    }
    else {
      this.allUtmCount = [];
      this.utmSouceList = [];
      this.allActionCount = [];
      this.getTableData();
      this.activetab = 'Table';
      this.activetab = 'Table';
    }
  }

  onUTMACtionSelect() {
    if (this.activetab == "Chart") {
      this.barChartData = [];
      this.getData();
    }
    else {
      this.allUtmCount = [];
      this.utmSouceList = [];
      this.allActionCount = [];
      this.getTableData();
      this.activetab = 'Table';
      this.activetab = 'Table';
    }
  }


  //Table page function

  getTableData() {
    this.bindMonths();
    this.loaderService.display(true);
    let hh = this.dataerange;
    this._commonService.GetMarkettingTableData(this.selectedValue, this.selectedAction, 'All').subscribe(response => {
      this.allUtmCount = response;
      if (this.allUtmCount != null) {
        let newdata = this.allUtmCount.map(al => al.UTMSource);
        let unique = [];
        let uni1 = [];
        newdata.forEach(element => {
          if (!unique.includes(element)) {
            unique.push(element);
            let img: any = {
              UtmSource: element,
              ShowMonthlyData: false,
              UtmData: this.allvalCount
            };
            uni1.push(img);
          }
        });
        this.utmSouceList = uni1;

      }

      this.loaderService.display(false);
    });

  }
  bindMonths() {
    this.currentYear = new Date().getFullYear();
    var today = new Date();
    this.range = [];
    if (this.selectedValue != null && this.selectedValue != 0) {
      var indexRange = this.selectedValue;
      var newDate = today;
      newDate.setMonth(newDate.getMonth() - this.selectedValue);
      for (var i = newDate; i <= new Date(); i.setMonth(newDate.getMonth() + 1)) {
        var month = i.toLocaleString('en-us', { month: 'short' });;
        this.range.push(month);
      }
    }
    this.monthList = this.range;
    this.monthcount = 1 + this.monthList.length;
  }

  GetMonthlyTotal(month: string, utmsource: string) {
    let total = 0;
    if (this.allUtmCount != null) {
      if (this.allUtmCount.findIndex(x => x.Month == month && x.UTMSource == utmsource) > -1) {
        total = this.allUtmCount.filter(x => x.Month == month && x.UTMSource == utmsource).map(i => i.Count)[0];
      }
    }
    return total;
  }
  GetActionMonthlyTotal(utmData: IUtmSource, month: string, action: string) {
    let total = 0;
    if (utmData != null && utmData.UtmData != null) {
      if (utmData.UtmData.findIndex(x => x.Month == month && x.Action == action) > -1) {
        total = utmData.UtmData.filter(x => x.Month == month && x.Action == action).map(i => i.Count)[0];
      }
    }
    return total;
  }

  showMonthlyCount(utmData: IUtmSource, index) {
    if (!utmData.ShowMonthlyData) {
      let item = utmData.UtmSource == "B+E" ? "B+E" : utmData.UtmSource;
      let currentData: any = {
        selectedValue: this.selectedValue,
        selectedAction: this.selectedAction,
        selectedUTMSource: item.toString()
      };
      this._commonService.GetMarkettingDashboardData1(currentData).subscribe(response => {

        utmData.UtmData = response;
        utmData.ShowMonthlyData = true;
        if (response != null) {
          let newdata = utmData.UtmData.map(al => al.Action);
          let unique = [];
          let uni1 = [];
          newdata.forEach(element => {
            if (!unique.includes(element)) {
              unique.push(element);
            }
          });
          this.tableactionList = unique;
        }
      });
    }
    else {
      utmData.ShowMonthlyData = false;
    }

  }

  getUtmActionList() {
    this._commonService.GetUTMActionList().subscribe(response => {
      var actions = response.map(o => ({ Action: o.Action }))
      this.actionList = actions.map(ar => JSON.stringify(ar))
        .filter((itm, idx, arr) => arr.indexOf(itm) === idx)
        .map(str => JSON.parse(str));
    });
  }

}
